// Shipping countries for checkout. The region (BiH, Srbija, Hrvatska) comes first; the
// rest of the EU follows, shipped through Fulfillio, paid by card in EUR.

import { CARD_COUNTRIES } from './cardPayment';

export const REGIONAL_COUNTRIES = [
  { code: 'BA', label: 'Bosnia and Herzegovina' },
  { code: 'RS', label: 'Serbia' },
  { code: 'HR', label: 'Croatia' },
];

// No longer offered at checkout, but past orders still carry it. Bulka has always used CG
// for Montenegro, which Intl.DisplayNames would otherwise show as Congo.
const FORMER_COUNTRIES = [
  { code: 'CG', label: 'Montenegro' },
];

const REGIONAL_CODES = REGIONAL_COUNTRIES.map(c => c.code);

export const EU_COUNTRIES = CARD_COUNTRIES.filter(code => !REGIONAL_CODES.includes(code));

/** EU, but not one of the regional countries: EUR, card only, shipped via Fulfillio. */
export const isEuOnlyCountry = (code) => EU_COUNTRIES.includes(code);

// Prices every EU country without its own row in the shipping table: a flat 7 EUR.
const EU_SHIPPING = { country: 'EU', price: 7, shipping_days: 10, shipping_information: '[]' };

// Croatian, not Bosnian: Chrome claims 'bs' but has no country names for it (falls back to English)
const LOCALE = { BA: 'hr', RU: 'ru', US: 'en' };

/** Country name in the display language. Regional names come from the translations. */
export function countryName(code, language, translate) {
  const known = [...REGIONAL_COUNTRIES, ...FORMER_COUNTRIES].find(c => c.code === code);
  if (known) return translate(known.label);
  try {
    return new Intl.DisplayNames([LOCALE[language] || 'en'], { type: 'region' }).of(code) || code;
  } catch (_) {
    return code;
  }
}

/** EU countries, alphabetical in the display language. */
export function sortedEuCountries(language, translate) {
  const collator = new Intl.Collator(LOCALE[language] || 'en');
  return EU_COUNTRIES
    .map(code => ({ code, name: countryName(code, language, translate) }))
    .sort((a, b) => collator.compare(a.name, b.name));
}

/** The shipping row for a country: its own, else the fixed EU rate for EU countries. */
export function shippingRowFor(rows, code) {
  const own = (rows || []).find(row => row.country === code);
  if (own) return own;
  return isEuOnlyCountry(code) ? EU_SHIPPING : null;
}
